import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../ui/Button';
export function AboutSection() {
  return <section className="py-24 bg-white overflow-hidden" data-id="element-31">
      <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-33">
          {/* Image Grid */}
          <div className="w-full lg:w-1/2 relative" data-id="element-34">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-brand-lighter rounded-full blur-3xl -z-10 opacity-50" data-id="element-35" />

            <div className="grid grid-cols-2 gap-4 relative" data-id="element-36">
              <div className="space-y-4 mt-8" data-id="element-37">
                <img src="https://cdn.magicpatterns.com/uploads/bSWABHBGqVKzy2mDFo1ntQ/20231218231601_IMG_0654-02.jpg" alt="Maisha doctor consulting with a patient at the clinic" className="rounded-2xl shadow-soft object-cover h-64 w-full" data-id="element-38" />
                <div className="bg-brand-navy p-6 rounded-2xl text-white shadow-soft-lg" data-id="element-39">
                  <div className="text-4xl font-heading font-bold text-brand-gold mb-2" data-id="element-40">
                    10+
                  </div>
                  <div className="text-sm font-medium text-slate-200" data-id="element-41">
                    Years of Healthcare Excellence
                  </div>
                </div>
              </div>
              <div className="space-y-4" data-id="element-42">
                <div className="bg-brand-red p-6 rounded-2xl text-white shadow-soft-lg" data-id="element-43">
                  <h3 className="font-heading font-bold text-xl mb-2" data-id="element-44">
                    Our Mission
                  </h3>
                  <p className="text-sm text-white/90" data-id="element-45">
                    To promote health and well-being by delivering professional,
                    compassionate, and evidence-based medical care.
                  </p>
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/jf5yCN4y2vq9FMaMGCpqo3/20231218232322_IMG_0670-01.jpg" alt="Maisha doctor examining a young patient with a stethoscope" className="rounded-2xl shadow-soft object-cover h-72 w-full" data-id="element-46" />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="w-full lg:w-1/2" data-id="element-47">
            <span className="text-brand-red font-semibold tracking-wider text-sm uppercase mb-3 block" data-id="element-48">
              Our Story
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-brand-navy mb-6 leading-tight" data-id="element-49">
              Dedicated to the Health of Our Community
            </h2>

            <p className="text-slate-600 text-lg mb-6 leading-relaxed" data-id="element-50">
              NORA-PACK TECHNICS (PTY) LTD OPERATES MAISHA MEDICAL CENTER,
              REGISTERED IN BOTSWANA SINCE 2013.
            </p>
            <p className="text-slate-600 text-lg mb-8 leading-relaxed" data-id="element-51">
              For over a decade, we have been committed to delivering
              accessible, quality medical services that prioritize patient care,
              innovation, and community well-being. Our team of experienced
              healthcare professionals offers comprehensive services designed to
              meet the needs of individuals and families across Botswana.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-52">
              {['Patient-centered approach to every treatment', 'State-of-the-art diagnostic and laboratory equipment', 'Experienced and compassionate medical staff', 'Comprehensive care for the whole family'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-53">
                  <CheckCircle2 className="w-6 h-6 text-brand-gold shrink-0 mt-0.5" data-id="element-54" />
                  <span className="text-slate-700 font-medium" data-id="element-55">{item}</span>
                </li>)}
            </ul>

            <div className="flex flex-wrap gap-4" data-id="element-56">
              <Button href="/about" variant="primary" data-id="element-57">
                Read Our Full Story
              </Button>
              <Button href="/doctors" variant="outline" data-id="element-58">
                Meet Our Doctors
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}